import React from 'react';
import LightBox from '../Lightbox';

const PhotoItem = ({ photo }) => {
  return <LightBox photo={photo} />;
};

export default PhotoItem;
